<div #screen id="screen">
  <div id="work-area">
    <h3>This is a context sentence.</h3>
    <h3 class="my-5">This a target
      <span class="drag-target"
            #p1
            [ngClass]="{'empty':isSlotEmpty(0), 'ready-to-place': mayBePlacedInSlot(0)}"
            (click)="selectSlot(0, p1)"
      >
        <span class="item"
              [ngClass]="{selected: isSelected(getSlotItem(0))}"
              *ngIf="getSlotItem(0)">{{getSlotItem(0).value}}</span>
      </span>
      for drag and drop
      <span class="drag-target"
            #p2
            [ngClass]="{'empty':isSlotEmpty(1), 'ready-to-place': mayBePlacedInSlot(1)}"
            (click)="selectSlot(1,p2)"

      >
      <span class="item"
            [ngClass]="{selected: isSelected(getSlotItem(1))}"
            *ngIf="getSlotItem(1)">{{getSlotItem(1).value}}</span>
      </span>.</h3>
    <h3>Here is some more text to <br> make a space for working area scrolling.</h3>
    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
    <h3 class="my-5">This a target
      <span class="drag-target"
            #p3
            [ngClass]="{'empty':isSlotEmpty(2), 'ready-to-place': mayBePlacedInSlot(2)}"
            (click)="selectSlot(2,p3)"
      >
        <span class="item"
              [ngClass]="{selected: isSelected(getSlotItem(2))}"
              *ngIf="getSlotItem(2)">{{getSlotItem(2).value}}</span>
      </span>
      for drag and drop
      <span class="drag-target"
            #p4
            [ngClass]="{'empty':isSlotEmpty(3), 'ready-to-place': mayBePlacedInSlot(3)}"
            (click)="selectSlot(3,p4)"

      >
      <span class="item"
            [ngClass]="{selected: isSelected(getSlotItem(3))}"
            *ngIf="getSlotItem(3)">{{getSlotItem(3).value}}</span>
      </span>.</h3>
  </div>
  <div id="shelf">
    <div class="items" >
      <span #emptyItem class="item empty ready-to-place" [ngClass]="{hide: !mayReturnSelectedToShelf()}"
            (click)="returnToShelf(emptyItem)"
      ></span>
      <span class="item"
            #i
            [ngClass]="{selected: isSelected(item), 'ready-to-place': shelfItemMayBeReplaced()}"
            *ngFor="let item of shelfItems"
            (click)="selectFromShelf(item, i)"
      >{{item.value}}</span>
    </div>
  </div>
</div>
